module.exports = __webpack_public_path__ + "img/interpackmaxi_k.03cd029e.png";